import React from 'react';
import { Row, Alert } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import { ResourceRequest } from '../../hooks/incidentResourceRequestHooks';
import { ResourceRequestFormFields } from '../utils/ResourceRequestTypes';

interface ResourceRequestorSectionProps {
  requestData?: ResourceRequest | null;
  isCompleted?: boolean;
}

const ResourceRequestorSection: React.FC<ResourceRequestorSectionProps> = ({
  requestData,
}) => {
  const { watch } = useFormContext<ResourceRequestFormFields>();

  return (
    <div className="border rounded p-3 mb-3">
      <h5 className="mb-2">👤 Requestor Section</h5>
      {requestData && requestData.requestor_signature && (
        <Alert variant="success">
          <small>
            Submitted by {requestData.requestor_name} on{' '}
            {requestData.requestor_signature_timestamp &&
              new Date(
                requestData.requestor_signature_timestamp
              ).toLocaleString()}
          </small>
        </Alert>
      )}
      <Row>
        <div className="col-6">
          <label className="form-label">Requestor Name</label>
          <input
            className="form-control"
            value={watch('requestor_name')}
            disabled
          />
        </div>
        <div className="col-6">
          <label className="form-label">
            Requestor Position (from incident roster)
          </label>
          <input
            className="form-control"
            value={watch('requestor_position')}
            disabled
          />
        </div>
      </Row>
    </div>
  );
};

export default ResourceRequestorSection;
